/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import {
  mdiMonitorAccount,
  mdiDatabase,
  mdiTextBox,
  mdiAccountArrowRight,
  mdiAccountTie,
  mdiAccount,
  mdiCog,
  mdiClipboardText,
  mdiBadgeAccount,
  mdiExclamationThick,
  mdiPencilOff,
  mdiAccountCancelOutline,
  mdiClockAlertOutline,
  mdiCalendarMonthOutline,
  mdiTimetable,
  mdiInformationOutline,
  mdiFileDocumentEditOutline,
  mdiFormatListBulletedType,
  mdiAccountDetailsOutline,
  mdiAccountCircle,
  mdiAccountCheck,
  mdiClipboardAccountOutline,
  mdiAccountConvert,
  mdiCalendar,
  mdiOfficeBuilding
} from '@mdi/js'
import CryptoJS from 'crypto-js'

const hrDashboard = {
  to: '/hr-dashboard',
  icon: mdiMonitorAccount,
  label: 'sidebar.dashboard'
  // label: 'Dashboard'
}

const employeeInfo = {
  to: '/employee-info',
  icon: mdiBadgeAccount,
  label: 'sidebarFin.personalInfo'
  // label: 'Personal Info'
}

const master = {
  label: 'sidebarFin.master',
  // label: 'Master',
  subLabel: 'Submenus Master',
  icon: mdiDatabase,
  menu: [
    {
      to: '/academic-year',
      label: 'sidebarFin.acaYear',
      // label: 'Academic Year',
      icon: mdiCalendar
    },
    {
      to: '/department',
      label: 'sidebarFin.department',
      // label: 'Department',
      icon: mdiOfficeBuilding
    },
    {
      to: '/work-unit',
      label: 'sidebarFin.workUnit',
      // label: 'Work Unit',
      icon: mdiOfficeBuilding,
      updateMark: true
    },
    {
      to: '/holidays',
      label: 'sidebarFin.holidays',
      // label: 'sidebarFin.holidays',
      icon: mdiDatabase
    },
    {
      to: '/committe-role',
      label: 'sidebarFin.committeeRole',
      // label: 'sidebarFin.committeeRole',
      icon: mdiDatabase
    },
    {
      to: '/career-path',
      label: 'sidebarFin.careerPath',
      // label: 'sidebarFin.careerPath',
      icon: mdiDatabase
    },
    {
      to: '/hrresponsibilityrole',
      label: 'sidebarFin.responsibilityRole',
      // label: 'Responsibility Role',
      icon: mdiDatabase
    },
    {
      to: '/hrposition',
      label: 'sidebarFin.hrposition',
      // label: 'sidebarFin.hrposition',
      icon: mdiDatabase
    },
    {
      to: '/mleave',
      label: 'sidebarFin.mleave',
      // label: 'sidebarFin.mleave',
      icon: mdiDatabase
    },
    {
      to: '/violation',
      label: 'sidebarFin.violation',
      // label: 'Violation',
      icon: mdiExclamationThick
    },
    {
      to: 'punishment-type',
      label: 'sidebarFin.punishmentType',
      // label: 'Punishment Type',
      icon: mdiPencilOff
    },
    {
      to: '/punishment-master',
      label: 'sidebarFin.punishment',
      // label: 'Punishment',
      icon: mdiPencilOff
    },
    {
      to: '/template-decree',
      label: 'sidebarFin.templateDecree',
      // label: 'Template Decree',
      icon: mdiAccountCancelOutline
    },
    {
      to: '/shift',
      label: 'sidebarFin.shift',
      // label: 'Shift',
      icon: mdiAccountConvert,
      updateMark: true
    }
  ]
}

const employee = {
  label: 'sidebarFin.employee',
  // label: 'Employee',
  subLabel: 'Employee',
  icon: mdiAccountCircle,
  menu: [
    {
      to: '/employee',
      label: 'sidebarFin.employees',
      // label: 'Employees',
      icon: mdiAccount
    },
    {
      to: '/employee-daily-attendance',
      label: 'sidebarFin.employeeDailyAttendance',
      // label: 'Employee Daily Attendance',
      icon: mdiAccountCheck
    },
    {
      to: '/employee-special-assignments',
      label: 'sidebarFin.specialEmployeeAssignments',
      // label: 'Special Employee Assignments',
      icon: mdiClipboardAccountOutline
    },
    {
      to: '/employee-attendance-report',
      label: 'sidebarFin.employeeAttendanceReport',
      // label: 'Employee Attendance Report',
      icon: mdiAccountCheck
    }
  ]
}

const workhour = {
  label: 'sidebarFin.workHour',
  // label: 'Workhour',
  subLabel: 'Submenus Punishment',
  icon: mdiClockAlertOutline,
  menu: [
    {
      to: '/work-hour-transaction',
      label: 'sidebarFin.workHour',
      // label: 'Work Hour',
      icon: mdiClockAlertOutline
    }
  ]
}

const overtime = {
  label: 'sidebarFin.overtime',
  // label: 'Overtime',
  subLabel: 'Submenus Overtime',
  icon: mdiClockAlertOutline,
  menu: [
    {
      to: '/over-time',
      label: 'sidebarFin.overtime',
      // label: 'Overtime',
      icon: mdiClockAlertOutline
    },
    {
      to: '/over-time-detail?personal=true',
      label: 'sidebarFin.overtimeSheet',
      // label: 'Overtime Sheet',
      icon: mdiTimetable
    },
    {
      to: '/over-time-report',
      label: 'sidebarFin.overtimeReport',
      // label: 'Overtime Report',
      icon: mdiTimetable
    }
  ]
}

const punishment = {
  label: 'sidebarFin.punishment',
  // label: 'Punishment',
  subLabel: 'Submenus Punishment',
  icon: mdiDatabase,
  menu: [
    {
      to: '/punishment-transaction',
      label: 'sidebarFin.punishmentTransaction',
      // label: 'Punishment Transaction',
      icon: mdiPencilOff
    }
  ]
}

const leave = {
  label: 'sidebarFin.leave',
  // label: 'Leave',
  subLabel: 'Submenus Leave',
  icon: mdiAccountArrowRight,
  menu: [
    {
      to: '/leave-dashboard',
      label: 'sidebarFin.leaveDashboard',
      // label: 'Leave Dashboard',
      icon: mdiAccountTie,
      forAccess: [],
      notAccess: []
    },
    {
      to: '/leave-balance',
      label: 'sidebarFin.leaveBalance',
      // label: 'Leave Balance',
      icon: mdiAccountTie
    },
    {
      to: '/leave-request',
      label: 'sidebarFin.leaveRequest',
      // label: 'Leave Request',
      icon: mdiAccountTie
    },
    {
      to: '/leave-addition',
      label: 'sidebarFin.leaveAddition',
      // label: 'Leave Addition',
      icon: mdiAccountTie
    },
    {
      to: '/leave-calendar',
      label: 'sidebarFin.leaveCalendar',
      // label: 'Leave Calendar',
      icon: mdiCalendarMonthOutline
    }
  ]
}

const programme = {
  label: 'sidebarFin.programme',
  // label: 'Programme',
  subLabel: 'Submenus Programme',
  icon: mdiMonitorAccount,
  menu: [
    {
      to: '/programme',
      label: 'sidebarFin.programme',
      // label: 'sidebarFin.programme',
      icon: mdiMonitorAccount
    }
    // ,
    // {
    //   to: '/programme-exception-time',
    //   label: 'Programme Exception Time',
    //   icon: mdiMonitorAccount
    // }
  ]
}

const contract = {
  label: 'sidebarFin.contract',
  // label: 'sidebarFin.contract',
  subLabel: 'Submenus Contract',
  icon: mdiFileDocumentEditOutline,
  menu: [
    {
      to: '/employee-contract',
      label: 'sidebarFin.employeeContract',
      // label: 'Employee Contract',
      icon: mdiAccountDetailsOutline
    },
    {
      to: '/contract-template',
      label: 'sidebarFin.contractTemplate',
      // label: 'Contract Template',
      icon: mdiFileDocumentEditOutline
    },
    {
      to: '/contract-type',
      label: 'sidebarFin.contractType',
      // label: 'Contract Type',
      icon: mdiFormatListBulletedType
    }
  ]
}

const training = {
  label: 'sidebarFin.training',
  // label: 'Training',
  subLabel: 'sidebarFin.training',
  // subLabel: 'Training',
  icon: mdiClipboardText,
  menu: [
    {
      to: '/employee-training',
      label: 'sidebarFin.employeeTraining',
      // label: 'Employee Training',
      icon: mdiClipboardText
    }
  ]
}

const report = {
  label: 'sidebarFin.report',
  // label: 'Report',
  subLabel: 'Report',
  icon: mdiTextBox,
  menu: [
    {
      to: '/leave-summary',
      label: 'sidebarFin.leaveSummary',
      // label: 'Leave Summary',
      icon: mdiTextBox
    },
    {
      to: '/punishment-report',
      label: 'sidebarFin.punishmentReport',
      // label: 'Punishment Report',
      icon: mdiTextBox
    }
  ]
}

const settings = {
  label: 'sidebarFin.settings',
  // label: 'Settings',
  subLabel: 'Submenus Settings',
  icon: mdiCog,
  menu: []
}

const reminder = {
  to: '/reminder-setting',
  label: 'sidebarFin.reminderSetting',
  // label: 'Reminder Setting',
  icon: mdiInformationOutline
}

// const expired = {
//   to: '/setting-expired-employee',
//   label: 'Setting for Expiring Date',
//   icon: mdiCog
// }

// const employee = {
//   to: '/employee',
//   label: 'Employees',
//   icon: mdiAccount
// }

const users = {
  to: '/users',
  label: 'sidebarFin.users',
  // label: 'Users',
  icon: mdiAccount
}

const Generals = []
Generals.push(hrDashboard)
Generals.push(employeeInfo)
// Generals.push(employeeInfo)

// if (localStorage.getItem('child')) {
//   const employeeChild = localStorage.getItem('child')

//   if (employeeChild !== '0') {
//     // console.log('cek jumlah child', employeeChild)
//     Generals.push(employeeInfo)
//   }
// }

// const Examples = []
Generals.push(master)
Generals.push(employee)
Generals.push(workhour)
Generals.push(overtime)
Generals.push(punishment)
Generals.push(leave)
Generals.push(programme)
Generals.push(contract)
Generals.push(training)
Generals.push(report)

// Role
settings.menu = []
settings.menu.push(employee)
if (localStorage.getItem('role')) {
  let check = 0
	const decryptedMessage = CryptoJS.AES.decrypt(localStorage.getItem('role'), 'amatra1609').toString(CryptoJS.enc.Utf8)
  const myArray = decryptedMessage.split(',')

  for (let i = 0; i < myArray.length; i++) {
    if (myArray[i] === 'ROLE_ADMIN' || myArray[i] === 'ROLE_ADMIN_HRD') {
      check += 1
    }
  }

  if (check > 0) {
    settings.menu = []
    // settings.menu.push(expired)
    settings.menu.push(reminder)
    // settings.menu.push(employee)
    settings.menu.push(users)
  }
}

Generals.push(settings)

export default Generals
